import { isEqual } from './obj.utils';

export const compareData = <T>(old: T, newData: T): T => {
  if (old === newData) return old;

  if (!old || !newData) return newData;

  return isEqual(old, newData) ? old : newData;
};
